<script lang="ts">
    import { getDashboardCtx } from "../../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { NoData } from "@/components";

    const store = getDashboardCtx();
</script>

<div
    class="referralsPanel__toolbar referralsPanel__toolbar--metrics"
>
    <div class="periodBar">
        <span class="periodBar__label">
            {translate("PARTNER_PERIOD", "Periodo")}:
            <strong>{store.rangeDaysLabel}</strong>
        </span>
        <span
            class="periodBar__updated"
            title={store.lastMetricsUpdatedAt
                ? store.formatDateTime(store.lastMetricsUpdatedAt)
                : translate(
                      "PARTNER_LAST_UPDATED_UNKNOWN",
                      "Sin datos todavía",
                  )}
        >
            {#if store.lastMetricsUpdatedAt}
                {translate(
                    "PARTNER_LAST_UPDATED",
                    "Actualizado",
                )}
                {" "}
                {store.relativeTime(store.lastMetricsUpdatedAt)}
            {:else}
                {translate(
                    "PARTNER_LAST_UPDATED_UNKNOWN",
                    "Sin datos todavía",
                )}
            {/if}
        </span>
    </div>

    <div
        class="rangePicker"
        aria-label={translate("PARTNER_PERIOD", "Periodo")}
    >
        <button
            type="button"
            class={store.range === "7d" ? "isActive" : ""}
            onclick={() => {
                store.range = "7d";
                void store.loadMetrics();
            }}
        >
            7
        </button>
        <button
            type="button"
            class={store.range === "30d" ? "isActive" : ""}
            onclick={() => {
                store.range = "30d";
                void store.loadMetrics();
            }}
        >
            30
        </button>
        <button
            type="button"
            class={store.range === "90d" ? "isActive" : ""}
            onclick={() => {
                store.range = "90d";
                void store.loadMetrics();
            }}
        >
            90
        </button>
    </div>
</div>

<div class="kpiGrid kpiGrid--3">
    <div class="kpi">
        <div class="kpi__value">{store.usersInstalled}</div>
        <div class="kpi__label">
            {translate("PARTNER_INSTALLS", "Instalaciones")}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">{store.usersRegistered}</div>
        <div class="kpi__label">
            {translate("PARTNER_SIGNUPS", "Registros")}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">{store.usersSubscribed}</div>
        <div class="kpi__label">
            {translate(
                "PARTNER_SUBSCRIBERS",
                "Suscriptores",
            )}
        </div>
    </div>
</div>

<div class="panelCard">
    <div class="panelCard__title">
        {translate(
            "LANG_PARTNER_USERS_TABLE",
            "Usuarios atribuidos",
        )}
    </div>
    {#if store.metricsHasUsers}
        <div class="tableLike">
            <div class="tableLike__head">
                <span
                    >{translate(
                        "LANG_PARTNER_COL_USER",
                        "Usuario",
                    )}</span
                >
                <span
                    >{translate(
                        "LANG_PARTNER_COL_STATUS",
                        "Estado",
                    )}</span
                >
                <span class="right">
                    {translate(
                        "LANG_PARTNER_COL_LAST",
                        "Última actividad",
                    )}
                </span>
            </div>
            <div class="tableLike__body">
                {#each store.usersList as u (u.id)}
                    <div class="tableLike__row">
                        <span class="mono"
                            >{u.emailMasked}</span
                        >
                        <span
                            class={`badge badge--${u.status}`}
                            >{store.formatStatus(u.status)}</span
                        >
                        <span class="right"
                            >{store.formatShortDay(
                                u.lastSeen,
                            )}</span
                        >
                    </div>
                {/each}
            </div>
        </div>
    {:else}
        <NoData
            params={{
                icon: "fa-user",
                title: translate(
                    "LANG_PARTNER_NO_USERS_TITLE",
                    "Sin usuarios atribuidos",
                ),
                description: translate(
                    "LANG_PARTNER_NO_USERS_DESC",
                    "Cuando haya usuarios asociados a tu enlace aparecerán aquí.",
                ),
            }}
        />
    {/if}
</div>
